/**
 * Every GraphQL document the «صفحات پزشکان» screen sends, built against the
 * contract in `parsina.bff.admin/src/graphql/typeDefs/doctorPage.js`. One file,
 * so a contract change is a diff against one place and a test can match a call
 * by its operation name.
 *
 * Timestamps are ISO-8601 strings; `null` means "never" (never published,
 * never suspended).
 */

const PAGE_FIELDS = `
  pageId slug status displayName councilNumber specialty
  publishedAt updatedAt suspendedReason suspendedBy suspendedAt publicUrl
`;

export const DOCTOR_PAGES_QUERY = `
  query DoctorPages($status: String, $query: String, $limit: Int, $offset: Int) {
    doctorPages(status: $status, query: $query, limit: $limit, offset: $offset) {
      total
      pages { ${PAGE_FIELDS} }
    }
  }
`;

export const SUSPEND_DOCTOR_PAGE = `
  mutation SuspendDoctorPage($pageId: ID!, $reason: String!) {
    suspendDoctorPage(pageId: $pageId, reason: $reason) { ${PAGE_FIELDS} }
  }
`;

export const RESTORE_DOCTOR_PAGE = `
  mutation RestoreDoctorPage($pageId: ID!) {
    restoreDoctorPage(pageId: $pageId) { ${PAGE_FIELDS} }
  }
`;
